import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';

// Loads the user's categories and exposes them as <select> options ({ value, label })
export function useCategoryOptions() {
    const categories = ref([]);

    const fetchCategories = () => {
        return apiClient.post('/get-categories.php')
            .then((response) => {
                categories.value = response.data;
            })
            .catch((error) => {
                console.error('Error fetching categories:', error);
            });
    };

    const categoryOptions = computed(() => categories.value.map((category) => ({
        value: category.category_id,
        label: category.category_name,
    })));

    return { categoryOptions, fetchCategories };
}
